<template>
    <div class="category-list-panel">
        <out-of-stock-brief v-if="noItems" :brief="brief" />
        <category-panel-item
            v-for="(category, categoryIdx) in categories"
            v-else
            :key="category.id + '.' + categoryIdx"
            :brief="brief"
            :category="category.category"
            @click.native="$emit('selected', category)"
        />
    </div>
</template>

<script>
    import CategoryPanelItem from './CategoryPanelItem.vue';
    import ActivationBriefProductConfigMixin from '../../mixins/ActivationBriefProductConfigMixin';
    import OutOfStockBrief from './OutOfStockBrief';
    export default {
        name:       'PanelCategoryItems',
        components: {
            CategoryPanelItem,
            OutOfStockBrief,
        },
        mixins: [
            ActivationBriefProductConfigMixin,
        ],
        props: {
            categories: {
                type:     Array,
                required: true,
            },
        },
        computed: {
            noItems() {
                return this.categories.length === 0;
            },
        },
    };
</script>

<style lang="scss" scoped>
.category-list-panel {
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    cursor: pointer;
    & > div:nth-child(odd) {
        margin-right: 10%;
        margin-bottom: 30px;
    }
}
</style>
